// list of cuisine filters
export const cuisine = [
  {
    cat: 'Cuisine',
    key: 'American',
    display: 'American'
  },
  {
    cat: 'Cuisine',
    key: 'Chinese',
    display: 'Chinese'
  },
  {
    cat: 'Cuisine',
    key: 'Japanese',
    display: 'Japanese'
  },
  {
    cat: 'Cuisine',
    key: 'Korean',
    display: 'Korean'
  },
  {
    cat: 'Cuisine',
    key: 'Mexican',
    display: 'Mexican'
  },
  {
    cat: 'Cuisine',
    key: 'Thai',
    display: 'Thai'
  },
  {
    cat: 'Cuisine',
    key: 'French',
    display: 'French'
  },
  {
    cat: 'Cuisine',
    key: 'Italian',
    display: 'Italian'
  },
  {
    cat: 'Cuisine',
    key: 'Spanish',
    display: 'Spanish'
  },
  {
    cat: 'Cuisine',
    key: 'Latin',
    display: 'Latin'
  },
  {
    cat: 'Cuisine',
    key: 'Middle-Eastern',
    display: 'Middle Eastern'
  },
  {
    cat: 'Cuisine',
    key: 'Indian',
    display: 'Indian'
  },
  {
    cat: 'Cuisine',
    key: 'Mediterranean',
    display: 'Mediterranean'
  }
]